module.exports = __webpack_public_path__ + "assets/img/rotate.76b531b9.png";